/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const DeleteButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.delete}
      tooltip={formatMessage({ id: "common.delete" })}
      css={labellessButtonCss}
      iconName="delete"
      {...props}
      dataCy="delete-button"
    />
  );
};

export default DeleteButton;
